import { render, staticRenderFns } from "./procSend_detail.vue?vue&type=template&id=a8dc6496&scoped=true"
import script from "./procSend_detail.vue?vue&type=script&lang=js"
export * from "./procSend_detail.vue?vue&type=script&lang=js"
import style0 from "./procSend_detail.vue?vue&type=style&index=0&id=a8dc6496&prod&scoped=true&lang=css"
import style1 from "./procSend_detail.vue?vue&type=style&index=1&id=a8dc6496&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8dc6496",
  null
  
)

export default component.exports